<template>
  <div class="about">
    <h1>关于我们</h1>
    <p>这是一个使用 Vue.js 和 Vue Router 构建的应用。</p>
    <router-link to="/">返回首页</router-link>
  </div>
</template>

<script>
export default {
  name: 'AboutView'
}
</script>

<style scoped>
.about {
  text-align: center;
  padding: 40px;
}

h1 {
  color: #42b883;
  margin-bottom: 20px;
}

p {
  font-size: 18px;
  margin-bottom: 30px;
}

a {
  color: #42b883;
  text-decoration: none;
  padding: 10px 20px;
  border: 2px solid #42b883;
  border-radius: 5px;
  transition: all 0.3s ease;
}

a:hover {
  background-color: #42b883;
  color: white;
}
</style>
